import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { WorkOrderModel } from './models/workOrder.model'
import { WorkOrderStatusModel } from './models/workOrder_status_model'

const API_URL = environment.apiUrl

@Injectable({
  providedIn: 'root',
})
export class WorkOrderService {
  constructor(private http: HttpClient) {}

  addWorkOrder(workOrder: WorkOrderModel): Observable<any> {
    return this.http
      .post(`${API_URL}/WorkOrder/CreateWorkOrder`, workOrder, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((error: any) => {
          console.error(error)
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updateWorkOrder(workOrder: WorkOrderModel): Observable<any> {
    return this.http
      .put(`${API_URL}/WorkOrder/UpdateWorkOrder`, workOrder, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((error: any) => {
          console.error(error)
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  deleteWorkOrder(workOrder: WorkOrderModel): Observable<any> {
    return this.http
      .put(`${API_URL}/WorkOrder/DeleteWorkOrder`, workOrder, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((error: any) => {
          console.error(error)
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllWorkOrders(): Observable<WorkOrderModel[]> {
    return this.http
      .get(`${API_URL}/WorkOrder/GetWorkOrders`, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((error: any) => {
          console.error(error)
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getWorkOrderById(workOrderId: number): Observable<WorkOrderModel> {
    return this.http
      .get(`${API_URL}/WorkOrder/GetWorkOrderById`, {
        params: { id: workOrderId },
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((error: any) => {
          console.error(error)
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getAllWorkOrdersStatus(): Observable<WorkOrderStatusModel[]> {
    return this.http
      .get(`${API_URL}/WorkOrder/GetWorkOrdersStatus`, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((error: any) => {
          console.error(error)
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  updateWorkOrderStatus(workOrderStatus: WorkOrderStatusModel): Observable<any> {
    return this.http
      .put(`${API_URL}/WorkOrder/UpdateWorkOrderStatus`, workOrderStatus, {
        withCredentials: true,
      })
      .pipe(
        map((response: any) => response),
        catchError((error: any) => {
          console.error(error)
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }


}
